'use strict';

import { createOptionsCard } from '../../cards/optionsCards';
import { Buildings, cardsData, isMobile } from '../../../settings';
import { CylinderControlPanel } from '../CylinderControlPanel/CylinderControlPanel';
import { changeLangToCurrent } from '../langSwitcher/langSwitcher';

export class FloorAmenities {
    constructor () {
        this.settings = null;
    }

    show(mesh) {
        if (!this.active) return;

        const floor = mesh.userData.floor;
        const data = this.getData(mesh);
        if (!data) return;

        const activeBuilding = Buildings.getActiveBuilding();
        const object = {
            assets: data.assets,
            floorNum: floor,
            engineId: mesh.name,
            propNum: `Floor plan`,
            buildingName: activeBuilding.info.labelName,
            buildingEngineId: activeBuilding.name
        };
        cardsData.cardMode.isAmenities = true;
        if (isMobile)
            document.querySelector('.additional-menu__container').classList.add('hidden');

        const card = createOptionsCard({object, settings: config, params: {}, isForeCompare: false});
        const floorPlanBtn = card?.querySelector('.options-card__plans-box_buttons-btn[data-type="2D"]')?.querySelector('.options-card__plans-box_buttons-tooltip');
        if (floorPlanBtn) {
            floorPlanBtn.setAttribute('data-dictionary','Floor plan');
            floorPlanBtn.textContent = changeLangToCurrent('Floor plan');
        }
    }
    
    addIcon(parent,mesh) {
        if (!this.active) return;
        const data = this.getData(mesh);
        if (!data) return;

        const amenitiesContainer = parent.querySelector('.floor-amenities');
        if (amenitiesContainer) {
            amenitiesContainer.classList.add('icon-info');
        }
    }

    getData(mesh) {
        const floor = mesh.userData.floor;
        const activeBuildingName = Buildings.getActiveBuilding().name;

        return this.settings[activeBuildingName]?.floorAmenities.find(el => floor >= el.from && floor <= el.to);
    }

    set settingsData(data) {
        this.settings = data;
    }

    get active(){
        return this.settings;
    }
}
